export type WorkoutSessionPhase = 'warmup' | 'main' | 'cooldown'

type SessionPhaseStepperProps = {
  currentPhase: WorkoutSessionPhase
}

const PHASES: { id: WorkoutSessionPhase; label: string }[] = [
  { id: 'warmup', label: 'Warm-up' },
  { id: 'main', label: 'Main' },
  { id: 'cooldown', label: 'Cool-down' },
]

export function SessionPhaseStepper({ currentPhase }: SessionPhaseStepperProps) {
  const currentIndex = PHASES.findIndex((p) => p.id === currentPhase)

  return (
    <div className="mb-4 flex items-center gap-0">
      {PHASES.map((phase, index) => (
        <div key={phase.id} className="flex items-center">
          <span
            className={`rounded-full border px-3 py-1 font-mono text-[10px] tracking-wider transition-all ${
              phase.id === currentPhase
                ? 'border-kilo-accent/30 bg-kilo-accent/15 text-kilo-accent'
                : index < currentIndex
                  ? 'text-kilo-soft'
                  : 'text-neutral-700'
            }`}
          >
            {phase.label}
          </span>
          {index < PHASES.length - 1 ? (
            <div className="mx-0.5 h-px w-4 bg-neutral-800" />
          ) : null}
        </div>
      ))}
    </div>
  )
}

export default SessionPhaseStepper
